import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IEventState }          from 'Redux/Slices/Event/EventSlice';
import { Event }                from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const cancelEventRequest = (state: Draft<IEventState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.lastUpdateId = null;
  state.updatedAt = Date.now();
};

export const cancelEventSuccess = (state: Draft<IEventState>, { type, payload }: PayloadAction<{
  event: Event
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.lastUpdateId = payload.event.id;
  state.entries = { ...state.entries, [payload.event.id]: payload.event };
};

export const cancelEventFailure = (state: Draft<IEventState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
